import { render, staticRenderFns } from "./FinanceReportsPeopleAndProjects.vue?vue&type=template&id=79322ecb&"
import script from "./FinanceReportsPeopleAndProjects.vue?vue&type=script&lang=js&"
export * from "./FinanceReportsPeopleAndProjects.vue?vue&type=script&lang=js&"
import style0 from "./FinanceReportsPeopleAndProjects.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports